import { userAgent } from "@Core/utils/UserAgent";
export class DeviceTypeQualifier {
    constructor() {
        this.key = "DeviceType";
    }
    process() {
        const deviceType = userAgent.getDeviceType(); // e.g., "Mobile", "Tablet", "Desktop"
        return deviceType !== null && deviceType !== void 0 ? deviceType : "Unknown";
    }
}
